exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account-form[data-v-3dfe510f] {\r\n  max-width: 460px;\n}\n.field-tip[data-v-3dfe510f] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  line-height: 16px;\r\n  margin-top: 4px;\n}\r\n", ""]);

// exports
